import { createFileRoute } from "@tanstack/react-router";
import { OrderPage } from "../components/shop/order-page.tsx";

export const Route = createFileRoute("/butik/bestallningar/$orderId")({ component: Screen });

function Screen() {
  const { orderId } = Route.useParams();
  return <OrderPage orderId={orderId} />;
}
